import { queryOptions } from "@tanstack/react-query";
import type { getPartnerListForm } from "../dtos/request/partner.request";
import { getPartnerDetail, getPartnerList, getPartnerQuotation, getPartnerStoreList, getPartnerTypeList } from "../v1/partner.service";

export const PARTNER_QUERY_KEY = {
  list: "partner-list",
  detail: "partner-detail",
  quotation: "partner-quotation",
  store: "partner-store",
  type: "partner-type",
} as const;

export const usePartnerList = (form: getPartnerListForm) =>
  queryOptions({
    queryKey: [PARTNER_QUERY_KEY.list, form.page, form.size],
    queryFn: () => getPartnerList(form),
    retry: 1,
  });

export const usePartnerStoreList = () =>
  queryOptions({
    queryKey: [PARTNER_QUERY_KEY.store],
    queryFn: getPartnerStoreList,
    retry: 1,
  });

/** 제휴사 유형 목록 — 생성/수정 모달의 유형 선택지. 거의 안 바뀌므로 길게 캐시 */
export const usePartnerTypeList = () =>
  queryOptions({
    queryKey: [PARTNER_QUERY_KEY.type],
    queryFn: getPartnerTypeList,
    staleTime: 1000 * 60 * 60,
    retry: 1,
  });

export const usePartnerDetail = (partnerId: string) =>
  queryOptions({
    queryKey: [PARTNER_QUERY_KEY.detail, partnerId],
    queryFn: () => getPartnerDetail(partnerId),
    enabled: !!partnerId,
  });

export const usePartnerQuotation = (partnerId: string) =>
  queryOptions({
    queryKey: [PARTNER_QUERY_KEY.quotation, partnerId],
    queryFn: () => getPartnerQuotation(partnerId),
    enabled: !!partnerId,
    retry: 1,
  });
